import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/kitaplar")({
  component: KitaplarLayout,
});

function KitaplarLayout() {
  return <Outlet />;
}